__turbopack_context__.v({
  "iframeEmbedContainer": "IFrameEmbed-module-scss-module__HLBn9W__iframeEmbedContainer",
});
